import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatRadioChange } from '@angular/material/radio';
import { InterviewQuestion } from '@app/models/recruiting/interview-question.model';
import { JobPostingInterviewMultipleChoiceTypes } from '../../enums/job-posting-interview-multiple-choice-types.enum';

@Component({
    selector: 'app-interview-multiple-choice',
    templateUrl: './interview-multiple-choice.template.html',
})
export class InterviewMultipleChoiceComponent implements OnInit {
    @Input() interviewQuestion: InterviewQuestion;
    @Input() interviewerFeedback: string[];
    @Output() valueChange: EventEmitter<string[]> = new EventEmitter<string[]>();

    checkboxValues: { value: string; checked: boolean }[] = [];
    jobPostingInterviewMultipleChoiceTypes = JobPostingInterviewMultipleChoiceTypes;

    ngOnInit(): void {
        if (this.interviewQuestion.questionTypeMode === this.jobPostingInterviewMultipleChoiceTypes.multiSelect) {
            this.loadCheckboxValues();
        }
    }

    onMultiSelectChange(matCheckboxChange: MatCheckboxChange): void {
        if (matCheckboxChange.checked) {
            this.interviewerFeedback
                ? this.interviewerFeedback.push(matCheckboxChange.source.value)
                : (this.interviewerFeedback = [matCheckboxChange.source.value]);

            this.loadCheckboxValues();
            this.valueChange.emit(this.interviewerFeedback);
            return;
        }

        const index = this.interviewerFeedback.indexOf(matCheckboxChange.source.value);
        this.interviewerFeedback.splice(index, 1);
        this.loadCheckboxValues();
        this.valueChange.emit(this.interviewerFeedback);
    }

    onSingleSelectChange(matRadioChange: MatRadioChange): void {
        this.interviewerFeedback = [matRadioChange.value];

        this.valueChange.emit(this.interviewerFeedback);
    }

    private loadCheckboxValues(): void {
        this.checkboxValues = this.interviewQuestion.questionValues.map((item: string) => {
            return { value: item, checked: this.interviewerFeedback?.indexOf(item) >= 0 ? true : false };
        });
    }
}
